import React, { useState, useEffect } from 'react';
import Header from '../../layouts/Header';
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import {
    Container,
    Row,
    Col,
    Card,
    Table,
    Button,
    Modal,
    Form,
    FormControl,
    FormSelect,
    InputGroup,
    Badge,
    Spinner,
    Alert,
    Pagination,
    Dropdown
} from 'react-bootstrap';
import {
    PlusCircle,
    Pencil,
    Trash,
    ArrowClockwise,
    CurrencyRupee,
    CartCheck,
    CartX,
    CashCoin,
    Calculator,
    CalendarMonth,
    CheckCircle,
    XCircle,
    Building,
    Shop,
    Filter,
    Download,
    Upload,
    ChevronLeft,
    ChevronRight
} from 'react-bootstrap-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const FoodDeliveryApp = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    
    const accessToken = localStorage.getItem("authToken");
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [deliveryAccess, setDeliveryAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        console.log("Hello 1");
        
        if (Array.isArray(access)) {
            console.log("Hello 2");
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("FoodDeliveryApp:"),
            );                                                              
            console.log("Hello 3");

            console.log("Filtered Access :", filteredAccess);
            
            setDeliveryAccess(filteredAccess);
        }
    }, [access]);

    console.log("Delivery Access:", deliveryAccess);

    const [outlets, setOutlets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [salesList, setSalesList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    
    // Separate states: one for filter, one for form
    const [filterMonth, setFilterMonth] = useState(new Date()); // For filtering/sorting
    const [formMonth, setFormMonth] = useState(new Date()); // For form only
    
    const [formData, setFormData] = useState({
        outletId: '',
        app: 'ZOMATO',
        saleFromDate: '',
        saleToDate: '',
        monthYear: moment().format('MM-YYYY'),
        totalSaleValue: '',
        deliveredCount: '',
        cancelledCount: '',
        totalOrders: '',
        deductions: '',
        totalPayouts: ''
    });

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [salesId, setSalesId] = useState('');
    const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    // Apps options
    const apps = ['ZOMATO', 'SWIGGY'];

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("FoodAppDelivery:")
            );
            setDeliveryAccess(filteredAccess);
        }
    }, [access]);

    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("outlet", { headers });

            if (response?.data?.status === true) {
                const activeOutlets = response?.data?.data?.outlets.filter(
                    (outlet) => outlet?.status === "ACTIVE"
                );
                setOutlets(activeOutlets);
            }
        } catch (error) {
            handleError(error);
        }
    };

    const getFoodDeliveryAppSales = async (page = currentPage, limit = itemsPerPage) => {
        try {
            setLoading(true);
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const monthYear = moment(filterMonth).format('MM-YYYY'); // Use filterMonth for API call

            // Prepare query parameters for server-side pagination
            const params = {
                page,
                limit,
                monthYear: monthYear
            };

            const response = await axiosInstance.get(`food-delivery-apps-sales/list`, {
                headers,
                params
            });

            console.log("Response :", response);

            if (response?.data) {
                if (response?.data?.data?.length > 0) {
                    setSalesList(response?.data?.data);
                    
                    // Update pagination info from API response
                    if (response?.data?.pagination) {
                        setTotalPages(response.data.pagination.totalPages);
                        setTotalRecords(response.data.pagination.totalRecords);
                        setCurrentPage(response.data.pagination.page);
                    } else {
                        // Fallback if API doesn't return pagination object
                        setTotalPages(Math.ceil(response.data.data.length / limit));
                        setTotalRecords(response.data.data.length);
                    }
                } else {
                    setSalesList([]);
                    setTotalPages(1);
                    setTotalRecords(0);
                    setCurrentPage(1);
                    
                    toast.info("No records found.", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                }
            } else {
                setSalesList([]);
                setTotalPages(1);
                setTotalRecords(0);
                setCurrentPage(1);
            }
        } catch (error) {
            console.error("Error fetching sales data:", error);
            handleError(error);
            
            // Reset pagination on error
            setTotalPages(1);
            setTotalRecords(0);
            setCurrentPage(1);
        } finally {
            setLoading(false);
        }
    };

    const handleError = (error) => {
        let errorMessage = "";
        if (error?.response) {
            if (error.response?.status === 406) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
            } else if (error.response?.status === 412) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error;
            } else {
                errorMessage = "Something went wrong. Please try again.";
            }
        }

        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "light",
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDateChange = (date, field) => {
        setFormData(prev => ({
            ...prev,
            [field]: date ? date.toISOString().split('T')[0] : ''
        }));
    };

    const handleFilterMonthChange = (date) => {
        setFilterMonth(date);
        setCurrentPage(1); // Reset to first page when changing filter
    };

    const handleFormMonthChange = (date) => {
        setFormMonth(date);
        setFormData(prev => ({
            ...prev,
            monthYear: moment(date).format('MM-YYYY')
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const payload = {
                ...formData,
                outletId: formData.outletId,
                totalSaleValue: parseFloat(formData.totalSaleValue),
                deliveredCount: parseInt(formData.deliveredCount),
                cancelledCount: parseInt(formData.cancelledCount),
                totalOrders: parseInt(formData.totalOrders),
                deductions: parseFloat(formData.deductions),
                totalPayouts: parseFloat(formData.totalPayouts),
                monthYear: formData.monthYear,
            };

            let response;
            if (editingRecord) {
                response = await axiosInstance.put(`food-delivery-apps-sales/`, {
                    ...payload,
                    _id: editingRecord._id
                }, { headers });
            } else {
                response = await axiosInstance.post(`food-delivery-apps-sales/`, payload, { headers });
            }

            if (response?.data?.status === true) {
                toast.success(editingRecord ? "Record updated successfully" : "Record created successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                setShowModal(false);
                setEditingRecord(null);
                resetForm();
                // Fetch data again with current filter settings
                getFoodDeliveryAppSales(currentPage, itemsPerPage);
            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenDeleteModal = (id) => {
        setShowDeleteConfirm(true);
        setSalesId(id);
    }

    const handleDelete = async () => {
        setDeleteBtnLoading(true);
        try {
            setLoading(true);
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const response = await axiosInstance.delete(`food-delivery-apps-sales`, {
                headers,
                data: { id: salesId }
            });

            if (response?.data?.status === true) {
                toast.success("Record deleted successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                setShowDeleteConfirm(false);
                getFoodDeliveryAppSales(currentPage, itemsPerPage);
            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
            setDeleteBtnLoading(false);
        }
    };

    const handleEdit = (record) => {
        setEditingRecord(record);
        // Set form month from record data
        const recordMonth = record.monthYear ? moment(record.monthYear, 'MM-YYYY').toDate() : new Date();
        setFormMonth(recordMonth);
        
        setFormData({
            outletId: record.outletId._id || record.outletId,
            app: record.app,
            saleFromDate: record.saleFromDate || '',
            saleToDate: record.saleToDate || '',
            monthYear: record.monthYear,
            totalSaleValue: record.totalSaleValue,
            deliveredCount: record.deliveredCount,
            cancelledCount: record.cancelledCount,
            totalOrders: record.totalOrders,
            deductions: record.deductions,
            totalPayouts: record.totalPayouts
        });
        setShowModal(true);
    };

    const resetForm = () => {
        setFormMonth(new Date());
        setFormData({
            outletId: '',
            app: 'ZOMATO',
            saleFromDate: '',
            saleToDate: '',
            monthYear: moment().format('MM-YYYY'),
            totalSaleValue: '',
            deliveredCount: '',
            cancelledCount: '',
            totalOrders: '',
            deductions: '',
            totalPayouts: ''
        });
    };

    // Pagination handlers
    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            getFoodDeliveryAppSales(pageNumber, itemsPerPage);
        }
    };

    const handleItemsPerPageChange = (limit) => {
        setItemsPerPage(limit);
        setCurrentPage(1); // Reset to first page when changing limit
        getFoodDeliveryAppSales(1, limit);
    };

    const calculateStats = () => {
        const totalSales = salesList.reduce((sum, item) => sum + parseFloat(item.totalSaleValue || 0), 0);
        const totalOrders = salesList.reduce((sum, item) => sum + parseInt(item.totalOrders || 0), 0);
        const totalPayouts = salesList.reduce((sum, item) => sum + parseFloat(item.totalPayouts || 0), 0);
        const totalDeductions = salesList.reduce((sum, item) => sum + parseFloat(item.deductions || 0), 0);
        const deliveredCount = salesList.reduce((sum, item) => sum + parseInt(item.deliveredCount || 0), 0);
        const cancelledCount = salesList.reduce((sum, item) => sum + parseInt(item.cancelledCount || 0), 0);
        const successRate = totalOrders > 0 ? ((deliveredCount / totalOrders) * 100).toFixed(2) : 0;

        return {
            totalSales,
            totalOrders,
            totalPayouts,
            totalDeductions,
            deliveredCount,
            cancelledCount,
            successRate
        };
    };

    useEffect(() => {
        getOutlets();
    }, []);

    useEffect(() => {
        // Only trigger API call when filterMonth changes (not formMonth)
        getFoodDeliveryAppSales(1, itemsPerPage);
    }, [filterMonth]);

    const stats = calculateStats();

    const getAppBadgeColor = (app) => {
        switch (app) {
            case 'ZOMATO': return 'danger';
            case 'SWIGGY': return 'warning';
            case 'UBER EATS': return 'primary';
            case 'FOODPANDA': return 'success';
            default: return 'secondary';
        }
    };

    // Generate pagination items
    const renderPaginationItems = () => {
        const items = [];
        const maxVisiblePages = 5;
        let startPage, endPage;

        if (totalPages <= maxVisiblePages) {
            // Less than max visible pages: show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // More than max visible pages: calculate start and end
            const maxPagesBeforeCurrent = Math.floor(maxVisiblePages / 2);
            const maxPagesAfterCurrent = Math.ceil(maxVisiblePages / 2) - 1;

            if (currentPage <= maxPagesBeforeCurrent) {
                startPage = 1;
                endPage = maxVisiblePages;
            } else if (currentPage + maxPagesAfterCurrent >= totalPages) {
                startPage = totalPages - maxVisiblePages + 1;
                endPage = totalPages;
            } else {
                startPage = currentPage - maxPagesBeforeCurrent;
                endPage = currentPage + maxPagesAfterCurrent;
            }
        }

        // Previous button
        items.push(
            <Pagination.Prev
                key="prev"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
            />
        );

        // First page
        if (startPage > 1) {
            items.push(
                <Pagination.Item
                    key={1}
                    active={1 === currentPage}
                    onClick={() => handlePageChange(1)}
                >
                    1
                </Pagination.Item>
            );
            if (startPage > 2) {
                items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
            }
        }

        // Page numbers
        for (let page = startPage; page <= endPage; page++) {
            items.push(
                <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => handlePageChange(page)}
                >
                    {page}
                </Pagination.Item>
            );
        }

        // Last page
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
            }
            items.push(
                <Pagination.Item
                    key={totalPages}
                    active={totalPages === currentPage}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        // Next button
        items.push(
            <Pagination.Next
                key="next"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            />
        );

        return items;
    };

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <Container fluid className="shadow-sm p-3 mb-5 bg-white rounded">
                    {/* Header */}
                    <Row className="mb-4 align-items-center">
                        <Col md={6}>
                            <h4 className="mb-1">
                                <Shop className="me-2" />
                                Food Delivery App Sales
                            </h4>
                            <p className="text-muted mb-1">Manage your food delivery app sales and payouts</p>
                        </Col>
                        <Col md={6} className="text-md-end">
                            <div className="d-flex justify-content-md-end gap-2">
                                {/* <div className="me-2">
                                    <DatePicker
                                        selected={filterMonth} // Use filterMonth for the header filter
                                        onChange={handleFilterMonthChange}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                        className="form-control"
                                        placeholderText="Select month"
                                    />
                                </div> */}
                                {(deliveryAccess.includes("FoodDeliveryApp:add") ||
                                    email === "contact@xpansecafe.com") && (
                                    <Button
                                        variant="primary"
                                        onClick={() => { 
                                            setEditingRecord(null);
                                            resetForm();
                                            setShowModal(true);
                                        }}
                                    >
                                        <PlusCircle className="me-1" /> Add Record
                                    </Button>
                                )}
                                
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => getFoodDeliveryAppSales(currentPage, itemsPerPage)}
                                    disabled={loading}
                                >
                                    <ArrowClockwise className={loading ? 'spinning' : ''} />
                                </Button>
                            </div>
                        </Col>
                        <hr />
                    </Row>

                    {/* Statistics Cards */}
                    <Row className="mb-4 g-3">
                        <Col xs={6} md={4} lg={2}>
                            <Card className="h-100 border-0 shadow-sm">
                                <Card.Body className="text-center">
                                    <CurrencyRupee size={24} className="text-success mb-2" />
                                    <h5 className="text-muted mb-1">Total Sales</h5>
                                    <h4 className="mb-0 text-success">
                                        ₹{stats.totalSales.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                    </h4>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={6} md={4} lg={2}>
                            <Card className="h-100 border-0 shadow-sm">
                                <Card.Body className="text-center">
                                    <CashCoin size={24} className="text-warning mb-2" />
                                    <h5 className="text-muted mb-1">Total Payouts</h5>
                                    <h4 className="mb-0 text-warning">
                                        ₹{stats.totalPayouts.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                    </h4>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={6} md={4} lg={2}>
                            <Card className="h-100 border-0 shadow-sm">
                                <Card.Body className="text-center">
                                    <CartCheck size={24} className="text-primary mb-2" />
                                    <h5 className="text-muted mb-1">Delivered</h5>
                                    <h4 className="mb-0 text-primary">{stats.deliveredCount}</h4>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={6} md={4} lg={2}>
                            <Card className="h-100 border-0 shadow-sm">
                                <Card.Body className="text-center">
                                    <CartX size={24} className="text-danger mb-2" />
                                    <h5 className="text-muted mb-1">Cancelled</h5>
                                    <h4 className="mb-0 text-danger">{stats.cancelledCount}</h4>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={6} md={4} lg={2}>
                            <Card className="h-100 border-0 shadow-sm">
                                <Card.Body className="text-center">
                                    <Calculator size={24} className="text-info mb-2" />
                                    <h5 className="text-muted mb-1">Total Orders</h5>
                                    <h4 className="mb-0 text-info">{stats.totalOrders}</h4>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={6} md={4} lg={2}>
                            <Form.Label className='fw-semibold'>Select Month</Form.Label>
                            <div className="me-2">
                                <DatePicker
                                    selected={filterMonth} // Use filterMonth for the header filter
                                    onChange={handleFilterMonthChange}
                                    dateFormat="MM/yyyy"
                                    showMonthYearPicker
                                    className="form-control"
                                    placeholderText="Select month"
                                />
                            </div>
                        </Col>
                    </Row>

                    {/* Data Table */}
                    <Card className="border-0 shadow-sm">
                        <Card.Body>
                            {loading ? (
                                <div className="text-center py-5">
                                    <Spinner animation="border" variant="primary" />
                                    <p className="mt-2 text-muted">Loading data...</p>
                                </div>
                            ) : salesList.length === 0 ? (
                                <Alert variant="info" className="text-center">
                                    <Building size={48} className="mb-3" />
                                    <h4>No Records Found</h4>
                                    <p>No sales records found for the selected month.</p>
                                </Alert>
                            ) : (
                                <>
                                    <div className="table-responsive">
                                        <Table hover className="mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Outlet</th>
                                                    <th>App</th>
                                                    <th className="text-center">Month</th>
                                                    <th className="text-end">Sales Value</th>
                                                    <th className="text-center">Orders</th>
                                                    <th className="text-end">Deductions</th>
                                                    <th className="text-end">Payouts</th>
                                                    {(deliveryAccess.includes("FoodDeliveryApp:update") &&
                                                        deliveryAccess.includes("FoodDeliveryApp:update") ||
                                                        email === "contact@xpansecafe.com") && (
                                                        <th className="text-center">Actions</th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {salesList.map((record, index) => (
                                                    <tr key={record._id}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <div>
                                                                <strong>{record.outletId?.name}</strong>
                                                                <div className="text-muted small">{record.outletId?.city}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <Badge bg={getAppBadgeColor(record.app)} className="px-3 py-2">
                                                                {record.app}
                                                            </Badge>
                                                        </td>
                                                        <td className="text-center">{record.monthYear}</td>
                                                        <td className="text-end fw-bold text-success">
                                                            ₹{parseFloat(record.totalSaleValue).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="d-flex flex-column align-items-center">
                                                                <span className="text-success">
                                                                    <CheckCircle size={12} /> {record.deliveredCount || 0}
                                                                </span>
                                                                <span className="text-danger">
                                                                    <XCircle size={12} /> {record.cancelledCount || 0}
                                                                </span>
                                                                <span className="text-muted small">Total: {record.totalOrders}</span>
                                                            </div>
                                                        </td>
                                                        <td className="text-end text-danger">
                                                            ₹{parseFloat(record.deductions).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                        </td>
                                                        <td className="text-end text-primary fw-bold">
                                                            ₹{parseFloat(record.totalPayouts).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                        </td>
                                                        {(deliveryAccess.includes("FoodDeliveryApp:update") &&
                                                            deliveryAccess.includes("FoodDeliveryApp:update") ||
                                                            email === "contact@xpansecafe.com") && (
                                                            <td className="text-center">
                                                                {(deliveryAccess.includes("FoodDeliveryApp:update") ||
                                                                    email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        variant="outline-primary"
                                                                        size="sm"
                                                                        className="me-1"
                                                                        onClick={() => handleEdit(record)}
                                                                    >
                                                                        <Pencil size={14} />
                                                                    </Button>
                                                                )}
                                                                {(deliveryAccess.includes("FoodDeliveryApp:delete") ||
                                                                    email === "contact@xpansecafe.com") && (
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() => handleOpenDeleteModal(record._id)}
                                                                    >
                                                                        <Trash size={14} />
                                                                    </Button>
                                                                )}
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>

                                    {/* Pagination Controls */}
                                    {totalPages > 1 && (
                                        <Row className="align-items-center mt-4">
                                            <Col md={4}>
                                                <div className="d-flex align-items-center">
                                                    <span className="me-2 text-muted">Show:</span>
                                                    <Dropdown>
                                                        <Dropdown.Toggle variant="outline-secondary" size="sm">
                                                            {itemsPerPage} per page
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {[5, 10, 20, 50, 100].map(size => (
                                                                <Dropdown.Item
                                                                    key={size}
                                                                    onClick={() => handleItemsPerPageChange(size)}
                                                                    active={itemsPerPage === size}
                                                                >
                                                                    {size} per page
                                                                </Dropdown.Item>
                                                            ))}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                    <span className="ms-3 text-muted">
                                                        Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalRecords)} of {totalRecords} records
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col md={8} className="text-md-end">
                                                <div className="d-flex justify-content-md-end align-items-center">
                                                    <Pagination className="mb-0">
                                                        {/* Previous Page Button */}
                                                        <Pagination.Prev 
                                                            onClick={() => handlePageChange(currentPage - 1)}
                                                            disabled={currentPage === 1}
                                                        />
                                                        
                                                        {/* Page Numbers */}
                                                        {(() => {
                                                            const pages = [];
                                                            const maxVisiblePages = 5;
                                                            let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
                                                            let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
                                                            
                                                            // Adjust start page if we're near the end
                                                            if (endPage - startPage + 1 < maxVisiblePages) {
                                                                startPage = Math.max(1, endPage - maxVisiblePages + 1);
                                                            }
                                                            
                                                            // First page
                                                            if (startPage > 1) {
                                                                pages.push(
                                                                    <Pagination.Item 
                                                                        key={1} 
                                                                        active={1 === currentPage}
                                                                        onClick={() => handlePageChange(1)}
                                                                    >
                                                                        1
                                                                    </Pagination.Item>
                                                                );
                                                                if (startPage > 2) {
                                                                    pages.push(<Pagination.Ellipsis key="ellipsis-start" />);
                                                                }
                                                            }
                                                            
                                                            // Middle pages
                                                            for (let i = startPage; i <= endPage; i++) {
                                                                pages.push(
                                                                    <Pagination.Item 
                                                                        key={i} 
                                                                        active={i === currentPage}
                                                                        onClick={() => handlePageChange(i)}
                                                                    >
                                                                        {i}
                                                                    </Pagination.Item>
                                                                );
                                                            }
                                                            
                                                            // Last page
                                                            if (endPage < totalPages) {
                                                                if (endPage < totalPages - 1) {
                                                                    pages.push(<Pagination.Ellipsis key="ellipsis-end" />);
                                                                }
                                                                pages.push(
                                                                    <Pagination.Item 
                                                                        key={totalPages} 
                                                                        active={totalPages === currentPage}
                                                                        onClick={() => handlePageChange(totalPages)}
                                                                    >
                                                                        {totalPages}
                                                                    </Pagination.Item>
                                                                );
                                                            }
                                                            
                                                            return pages;
                                                        })()}
                                                        
                                                        {/* Next Page Button */}
                                                        <Pagination.Next 
                                                            onClick={() => handlePageChange(currentPage + 1)}
                                                            disabled={currentPage === totalPages}
                                                        />
                                                    </Pagination>
                                                    
                                                    {/* Optional: Jump to page input */}
                                                    <div className="ms-3 d-flex align-items-center">
                                                        <span className="text-muted me-2">Go to:</span>
                                                        <FormControl
                                                            type="number"
                                                            min="1"
                                                            max={totalPages}
                                                            value={currentPage}
                                                            onChange={(e) => {
                                                                const page = parseInt(e.target.value);
                                                                if (page >= 1 && page <= totalPages) {
                                                                    handlePageChange(page);
                                                                }
                                                            }}
                                                            style={{ width: '70px' }}
                                                            size="sm"
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </>
                            )}
                        </Card.Body>
                    </Card>

                    {/* Add/Edit Modal */}
                    <Modal
                        show={showModal}
                        onHide={() => {
                            setShowModal(false);
                            setEditingRecord(null);
                            resetForm();
                        }}
                        size="lg"
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {editingRecord ? "Edit Sales Record" : "Add New Sales Record"}
                            </Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Outlet</Form.Label>
                                            <FormSelect
                                                name="outletId"
                                                value={formData.outletId}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Select Outlet</option>
                                                {outlets.map((outlet) => (
                                                    <option key={outlet._id} value={outlet._id}>
                                                        {outlet.name} - {outlet.city}
                                                    </option>
                                                ))}
                                            </FormSelect>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Delivery App</Form.Label>
                                            <FormSelect
                                                name="app"
                                                value={formData.app}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Select App</option>
                                                {apps.map((app) => (
                                                    <option key={app} value={app}>{app}</option>
                                                ))}
                                            </FormSelect>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold w-100'>Month Year</Form.Label>
                                            <DatePicker
                                                selected={formMonth} // Use formMonth for form
                                                onChange={handleFormMonthChange}
                                                dateFormat="MM/yyyy"
                                                showMonthYearPicker
                                                className="form-control w-100"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Total Sales Value (₹)</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text><CurrencyRupee /></InputGroup.Text>
                                                <FormControl
                                                    type="number"
                                                    step="0.01"
                                                    name="totalSaleValue"
                                                    value={formData.totalSaleValue}
                                                    onChange={handleInputChange}
                                                    required
                                                    placeholder="Enter total sales value"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Delivered Count</Form.Label>
                                            <FormControl
                                                type="number"
                                                name="deliveredCount"
                                                value={formData.deliveredCount}
                                                onChange={handleInputChange}
                                                required
                                                placeholder="Delivered orders"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Cancelled Count</Form.Label>
                                            <FormControl
                                                type="number"
                                                name="cancelledCount"
                                                value={formData.cancelledCount}
                                                onChange={handleInputChange}
                                                required
                                                placeholder="Cancelled orders"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Total Orders</Form.Label>
                                            <FormControl
                                                type="number"
                                                name="totalOrders"
                                                value={formData.totalOrders}
                                                onChange={handleInputChange}
                                                required
                                                placeholder="Total orders"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Deductions (₹)</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text><Calculator /></InputGroup.Text>
                                                <FormControl
                                                    type="number"
                                                    step="0.01"
                                                    name="deductions"
                                                    value={formData.deductions}
                                                    onChange={handleInputChange}
                                                    required
                                                    placeholder="Enter deductions"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold'>Total Payouts (₹)</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text><CashCoin /></InputGroup.Text>
                                                <FormControl
                                                    type="number"
                                                    step="0.01"
                                                    name="totalPayouts"
                                                    value={formData.totalPayouts}
                                                    onChange={handleInputChange}
                                                    required
                                                    placeholder="Enter total payouts"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold w-100'>Sale From Date</Form.Label>
                                            <DatePicker
                                                selected={formData.saleFromDate ? new Date(formData.saleFromDate) : null}
                                                onChange={(date) => handleDateChange(date, 'saleFromDate')}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                placeholderText="Select start date"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className='fw-semibold w-100'>Sale To Date</Form.Label>
                                            <DatePicker
                                                selected={formData.saleToDate ? new Date(formData.saleToDate) : null}
                                                onChange={(date) => handleDateChange(date, 'saleToDate')}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                placeholderText="Select end date"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={() => {
                                        setShowModal(false);
                                        setEditingRecord(null);
                                        resetForm();
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            {editingRecord ? 'Updating...' : 'Creating...'}
                                        </>
                                    ) : (
                                        editingRecord ? 'Update Record' : 'Create Record'
                                    )}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>

                    {/* Delete Confirmation Modal */}
                    <Modal
                        show={showDeleteConfirm}
                        onHide={() => setShowDeleteConfirm(false)}
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title className="text-danger">
                                <i className="ri-delete-bin-line me-2"></i>
                                Confirm Deletion
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Alert variant="warning" className="mb-0">
                                <i className="ri-alert-line me-2"></i>
                                Are you sure you want to delete ?
                                This action cannot be undone and will remove all associated data.
                            </Alert>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="outline-secondary"
                                onClick={() => setShowDeleteConfirm(false)}
                                disabled={deleteBtnLoading}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="danger"
                                onClick={handleDelete}
                                disabled={deleteBtnLoading}
                            >
                                {deleteBtnLoading ? (
                                    <>
                                        <Spinner size="sm" className="me-2" />
                                        Deleting...
                                    </>
                                ) : (
                                    'Delete Unit'
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Container>
            </div>

            <style jsx>{`
                .spinning {
                    animation: spin 1s linear infinite;
                }
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                .table th {
                    background-color: #f8f9fa;
                    border-top: none;
                    font-weight: 600;
                    color: #495057;
                }
                .table td {
                    vertical-align: middle;
                }
                .card {
                    transition: transform 0.2s;
                }
                
                /* Pagination styles */
                .page-item.active .page-link {
                    background-color: #0d6efd;
                    border-color: #0d6efd;
                }
                .page-link {
                    color: #0d6efd;
                    cursor: pointer;
                }
                .page-link:hover {
                    color: #0a58ca;
                }
                .pagination .page-item.disabled .page-link {
                    cursor: not-allowed;
                    opacity: 0.6;
                }
                .dropdown-toggle::after {
                    margin-left: 0.5rem;
                }
            `}</style>
            {/* .card:hover {
                transform: translateY(-2px);
            } */}
        </React.Fragment>
    );
};

export default FoodDeliveryApp;